import Run from './Run'

/**
 * Store object has its own internal state and public functions
 * to manipulate that state.
 */
export default function () {
  this.savedRuns = []
  this.currentRun = null

  const startNewRun = () => {
    this.currentRun = new Run()
    return this.currentRun
  }

  const getCurrentRun = () => {
    if (!this.currentRun) {
      return startNewRun()
    }
    return this.currentRun
  }

  /**
   * Runs that are saved in the local storage should be stored
   * in a stringified JSON.
   * Note that the user can change this on their end, and then
   * this call will fail. We don't protect against any of that
   * here.
   */
  const getSavedRuns = () => {
    const runs = localStorage.getItem('savedRuns') || '[]'
    return JSON.parse(runs)
  }

  /**
   * Saving the current run into local storage
   */
  const saveRun = ({ name }) => {
    if (!this.currentRun) {
      // This is an error: there's nothing to be saved
      return -1
    }
    if (this.currentRun.getCurrentStep() < 3) {
      // This is an error: we'd only save a run if it's at the
      // very last step.
      return -2
    }

    // Saving the name for this Run object first
    this.currentRun.setName(name)

    var savedRuns = getSavedRuns()
    savedRuns.push(this.currentRun.getAsJson())

    localStorage.setItem('savedRuns', JSON.stringify(savedRuns))

    return 0
  }

  const deleteSavedRun = ({ index }) => {
    const savedRuns = getSavedRuns()
    savedRuns.splice(index, 1)
    localStorage.setItem('savedRuns', JSON.stringify(savedRuns))
  }

  const loadSavedRun = ({ savedData }) => {
    const run = new Run()
    run.addDataFromJson(savedData)
    this.currentRun = run
  }

  return {
    startNewRun,
    getCurrentRun,
    saveRun,
    getSavedRuns,
    deleteSavedRun,
    loadSavedRun,
  }
}
